module.exports = __webpack_public_path__ + "bed-quilt2.b7669dcd.png";